import { render, staticRenderFns } from "./GoodsConsult.vue?vue&type=template&id=0516fdfe&scoped=true&"
import script from "./GoodsConsult.vue?vue&type=script&lang=js&"
export * from "./GoodsConsult.vue?vue&type=script&lang=js&"
import style0 from "./GoodsConsult.vue?vue&type=style&index=0&id=0516fdfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0516fdfe",
  null
  
)

export default component.exports